import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from "react-router-dom";
import Api from '../api/api';
import DocumentMeta from 'react-document-meta';
import LoadingBar from 'react-top-loading-bar';

import blogHead from './../assets/img/blog-head.png';

import collection1 from './../assets/img/collection-1.png';
import collection2 from './../assets/img/collection-2.png';



class Blogs extends React.Component {

    state={
        data:'',
        ref:React.createRef(null)
    }

    componentDidMount(){
        document.getElementById("fav-icon").href = process.env.PUBLIC_URL + "/CERAFINI_Blog.png";
        const {ref} = this.state;
        ref.current.continuousStart(10);


        Api.getblog().then((response)=>{
            this.setState({data:response.data.blogs});
            ref.current.complete();
        })

        Api.getMetaTags().then( ({data}) => {
            
            const {langTxt} = this.props;
            const {description, tags: keywords} = data.blogs_tags["content_" + langTxt];

            this.setState({metatags: {
                title: 'Blog / Cerafini',
                description,
                meta: {
                  charset: 'utf-8',
                  name: {
                    keywords
                  }
                }
            }});
        });
    }

    renderBlog = (data,langTxt,langUrl) => {
        return(
            data.map((item,i)=>{
                return (
                    <>
                    <Link to={langUrl + "/blog/" + item.id } className="blog-details">
                            <img src={item.cover_image} alt="img"/>
                            <div className="blog-details-text">
                                <p className="blog-date">{item.published_at}</p>
                                <div className="title-read">
                                    <p className="blog-title">{item["title_" + langTxt]}</p>
                                    <Link className="read-more-btn" to={langUrl + "/blog/" + item.id }>Read</Link>
                                </div>
                            </div>
                    </Link>
                    {((i+1)%4 === 0)?<div className="empty-div"></div>: ''}
                    </>
                )
            })
        )
    }

    render (){
        const {data,metatags} = this.state;
        const {langTxt, langUrl} = this.props;
        return(
            <DocumentMeta {...metatags}>
                <LoadingBar color='#000' height={4} ref={this.state.ref} />
                <div className="blog-page page">
                    {(data)?
                        <>
                            <div className="blog-page-head">
                                <img src={blogHead} alt=""/>
                            </div>
                            <div className="blog-page-items">
                                {this.renderBlog(data,langTxt,langUrl)}
                            </div>
                        </>
                        :<></>
                    }
                </div>
            </DocumentMeta>
        );
    }
}


// what props do i need to get from the state for this component?
const mapStateToProps = (state) => {
    // get the props needed for this component from the state of the store.
    return {
        langTxt: (state.lang && state.lang.text) || 'en',
        langUrl: (state.lang && state.lang.url) || '',
    }
}

// what events will occur that will change the state in this component
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)(Blogs) );

